var config = {
  //HOST: 'http://localhost:8081/'
 HOST:'https://transportapi.maha-info.com/'
 
 
}

var api = {
  //TransportApp
  POST_USER_MOBILE_OTP: 'api/postMobileOTP',
  POST_USER_MOBILE_OTP_VERIFIED: 'api/VerifiedMobileOTP',
  POST_VEHICLE_INFO: 'api/postVehicle',
  GET_VEHICLE_TYPE_INFO: 'api/gettVehiclesTypes',
  GET_VEHICLE_INFORMATION: 'api/gettVehiclesdetile',
  GET_KAMGAR_INFORMATION: 'api/gettKamgardetile',
  GET_KAMGAR_DETAILS: 'api/gettKamgarInfo',
  PUT_VEHICLE_INFO: 'api/putVehicle',
  PUT_CHANGE_USER_PASS: 'api/putChangePass',
  PUT_OTP_NEW_PASSWORD: 'api/putNewOTPPassword',
  //Sign
  POST_SIGNIN: 'api/postSignIn',
  POST_LOGIN: 'api/GetLogin',

  POST_EMPLOYEE_INFO: 'api/postWorker',
  POST_MUKADAM_INFO: 'api/postMukadam',
  POST_TRANSPORT_INFO: 'api/postTransInformation',
  GET_MUKADAM_INFORMATION: 'api/getMukadamdetiles',
  PUT_MUKADAM_INFO: 'api/putMukadam',
  GET_MUKADAMLIST: 'api/getMukadamlist',
  GET_TALUKALIST: 'api/getTaluka',
  GET_DISTRICLIST: 'api/getDistrict',
  GET_STATELIST: 'api/gettVehiclesdetile',
  GET_TRANSPORTER_DETAILS_INFORMATION:'api/getTransporterInfo',
  GET_TRANSPORTER_INFORMATION:'api/getTransporterInfo'

}




module.exports = { config, api }


// WEBPACK FOOTER //
// ./src/constants/constants.js